import { inject, Injectable, Injector, OnDestroy } from '@angular/core';
import { AuthService } from '@core/auth.service';
import { UserService } from '@core/services/user.service';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TreezorSessionKeepaliveService implements OnDestroy {
  private readonly authService = inject(AuthService);
  private readonly injector = inject(Injector);

  private readonly keepaliveDelayMs = 4 * 60_000;
  private refreshInFlight = false;
  private refreshTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnDestroy(): void {
    this.clearTimer();
  }

  registerRefreshingRequest(url: string): void {
    if (!this.authService.hasValidToken() || !this.shouldTrackUrl(url)) {
      return;
    }

    this.armTimer();
  }

  shouldTrackUrl(url: string): boolean {
    const normalizedUrl = url.replace(/^https?:\/\/[^/]+/i, '').toLowerCase();
    return normalizedUrl.includes('/account/balance') || normalizedUrl.includes('/transfers');
  }

  private armTimer(): void {
    this.clearTimer();
    this.refreshTimer = setTimeout(() => this.runKeepalive(), this.keepaliveDelayMs);
  }

  private clearTimer(): void {
    if (this.refreshTimer !== null) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = null;
    }
  }

  private runKeepalive(): void {
    if (!this.authService.hasValidToken() || this.refreshInFlight) {
      return;
    }

    const userService = this.injector.get(UserService);

    this.refreshInFlight = true;

    userService
      .getBalance(true, true, true)
      .pipe(
        finalize(() => {
          this.refreshInFlight = false;
        })
      )
      .subscribe({
        next: () => {
          this.armTimer();
        },
        error: error => {
          console.warn('Failed to refresh Treezor session automatically.', error);
        },
      });
  }
}


